<div class="interactive-scoring-image-container">
    <image-with-artifacts [cellData]="cellData" *ngIf="painterImage$ | async as painterImage" [painterImage]="painterImage" (painterImageChange)="painterImage$.next($event)"></image-with-artifacts>
</div>
<div class="interactive-scoring-image-results">
    <deephub-report-interactive-scoring-image-header class="mbot16" [title]="cellData.fileName"></deephub-report-interactive-scoring-image-header>
    <div class="interactive-scoring-image-results__values">
        <deephub-object-detection-prediction-widget [predictions]="cellData.prediction" [threshold]="threshold" (togglePrediction)="painterImageUpdateTrigger$.next($event)"></deephub-object-detection-prediction-widget>
    </div>
</div>
